import type { ISubAction } from 'pages/Batch/utils/analytics';

export const NONE_THUMBNAIL = 'https://cdn-effects-thumbnails.picsart.com/thumbnails/f3c6dd59-c929-4161-a89e-e1fb04f4b416.png';

export interface IEnhanceEffect {
  name: string;
  effectId: string | null;
  intensity: number;
  thumbnail: string;
}

export const SMART_ADJUSTMENT_EFFECTS: Record<string, IEnhanceEffect> = {
  None: {
    name: 'None',
    effectId: null,
    intensity: 0,
    thumbnail: NONE_THUMBNAIL,
  },
  HDR1: {
    name: 'Contrast',
    effectId: 'HDR1',
    intensity: 35,
    thumbnail: 'https://cdn-effects-thumbnails.picsart.com/thumbnails/d788509f-86b7-48e6-a0e6-7fa23184bd0a.jpg',
  },
  Sharpen: {
    name: 'Sharpen',
    effectId: 'Sharpen',
    intensity: 35,
    thumbnail: 'https://cdn-effects-thumbnails.picsart.com/thumbnails/c29d0fb6-a753-423a-8d4d-766883405051.jpg',
  },
  Noise1: {
    name: 'Noise',
    effectId: 'noise1',
    intensity: 35,
    thumbnail: 'https://cdn-effects-thumbnails.picsart.com/thumbnails/152320da-cd7b-447c-b6b5-0b010a5a4fcd.jpg',
  },
  GRNG: {
    name: 'Urban',
    effectId: 'grng',
    intensity: 35,
    thumbnail: 'https://cdn-effects-thumbnails.picsart.com/thumbnails/6ad14acf-0dbb-4a8a-a65b-9b81ac333d6d.jpg',
  },
  'INDIE 1': {
    name: 'Golden',
    effectId: 'Indie_Kid1',
    intensity: 35,
    thumbnail: 'https://cdn-effects-thumbnails.picsart.com/thumbnails/7da1c2e8-1d07-46de-9929-01c6d316ac80.jpg',
  },
  'B&W': {
    name: 'B&W',
    effectId: 'BW',
    intensity: 100,
    thumbnail: 'https://cdn-effects-thumbnails.picsart.com/thumbnails/9e45f562-5fc6-45d9-84fd-3cf98fe89cab.jpg',
  },
};

export const BACKGROUND_BLUR_EFFECTS: Record<string, IEnhanceEffect> = {
  None: {
    name: 'None',
    effectId: null,
    intensity: 100,
    thumbnail: NONE_THUMBNAIL,
  },
  GBlur: {
    name: 'GBlur',
    effectId: 'gblur',
    intensity: 25,
    thumbnail: 'https://cdn-cms-uploads.picsart.com/cms-uploads/6b361845-378a-4936-9f46-bc165504a282.jpg',
  },
  'Smart Blur': {
    name: 'Smart Blur',
    effectId: 'Smart_Blur',
    intensity: 60,
    thumbnail: 'https://cdn-cms-uploads.picsart.com/cms-uploads/51dd93be-5074-4c8d-ab17-9124a0556e84.jpg',
  },
  'Motion Blur': {
    name: 'Motion Blur',
    effectId: 'Motion_Blur',
    intensity: 60,
    thumbnail: 'https://cdn-cms-uploads.picsart.com/cms-uploads/b742f532-90ab-4e2b-88df-72bda6ab7c55.jpg',
  },
  'Focal Zoom': {
    name: 'Focal Zoom',
    effectId: 'Focal_Zoom',
    intensity: 60,
    thumbnail: 'https://cdn-cms-uploads.picsart.com/cms-uploads/010d6e1b-d7be-46e7-a5be-a0274238b684.jpg',
  },
};

export interface IEnhanceSubToolsParams {
  itemKeys: string[];
  itemIntensities: Record<string, number>;
  smartAdjustment: string | null;
  smartAdjustmentIntensity: number;
  backgroundBlur: string | null;
  backgroundBlurIntensity: number;
}

export function buildEnhancePerItemSubTools(params: IEnhanceSubToolsParams): ISubAction[][] {
  const { itemKeys, itemIntensities, smartAdjustment, smartAdjustmentIntensity, backgroundBlur, backgroundBlurIntensity } = params;

  const hasSmart = !!smartAdjustment && smartAdjustment !== 'None';
  const hasBlur = !!backgroundBlur && backgroundBlur !== 'None';

  const smartEffect = hasSmart ? SMART_ADJUSTMENT_EFFECTS[smartAdjustment!] : null;
  const blurEffect = hasBlur ? BACKGROUND_BLUR_EFFECTS[backgroundBlur!] : null;

  return itemKeys.map(key => {
    const intensityPct = Math.round((itemIntensities[key] ?? 1) * 100);
    const entries: ISubAction[] = [{ name: 'intensity', value: `${intensityPct}%` }];

    if (smartEffect) {
      entries.push({
        name: 'smart_adjustments',
        value: { item: smartEffect.name, intensity: `${smartAdjustmentIntensity}%` },
      });
    }

    if (blurEffect) {
      entries.push({
        name: 'bg_blur',
        value: { item: blurEffect.name, intensity: `${backgroundBlurIntensity}%` },
      });
    }

    return entries;
  });
}
